<template>
  <div>
    <box class="main-top-margin">
      <v-row dense>
        <v-col cols="12" class="px-4 py-6">
          <div v-if="isLoading" class="text-center ma-12">
              <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
          </div>

          <template v-else>

            <v-form v-model="isValid" >


                <div v-for="language in languages" :key="language.id">

  <SubHeader :text="$t('HELP-TEXT-LABEL-TRANSLATION-'+language.shortcode.toUpperCase())" />
 <tiptap-vuetify
      style="margin-bottom: 1em;"
      class="tiptap-editor" 
      v-model="item.contents[language.shortcode]"
      :extensions="extensions"
    />                   

                </div>
 
            </v-form>
          </template>
        
        </v-col>
      </v-row>
      
    </box>
    <box class="mt-2" background="transparent" borderColor="transparent" padding="1em 0">
    
    <div class="d-flex justify-end">
        <v-btn color="secondary" :loading="isSaving"  bottom right  @click="save()" style="z-index:999;">
            <small><lang t="GLOBAL-BTN-SAVE" /></small>
          </v-btn>
    </div>

</box>
  </div>
      
</template>

<script>
import Vue from "vue";
import { TiptapVuetify, Heading, Bold,Image, Italic, Strike, Underline,  Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, History } from 'tiptap-vuetify'
import FileUploader from "./FileUploader.vue";
import Box from "../../../components/ui-elements/Box.vue";
import SubHeader from "../../../components/ui-elements/SubHeader.vue";

export default Vue.extend({
   components: { TiptapVuetify, Box, SubHeader },
  data() {
    return {
      isSaving: false,
      isLoading: true,
      item: {
        id: 1,
        name: '',
        contents: {}
      },
      extensions: [
          History,
          Blockquote,
          Link,
          Underline,
          Strike,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3]
            }
          }],
          Bold,
        Paragraph,
          [Image, {
            options: {
              imageSourcesOverride: true,
              imageSources: [
                { component: FileUploader, name: this.$t('Upload') }
              ]
            }
          }]
      ],
      content: `
      <h1>Yay Headlines!</h1>
      <p>All these <strong>cool tags</strong> are working now.</p>
    `
     
    };
  },

  created() {
    this.initialize();
  },

  computed: {

      languages() {
        return this.$store.state.languages;
      }
  },

  methods: {

    initialize() {

        this.isLoading = true;

        this.axios.get(`helptexts/${this.$route.params.id}`).then(res => {
          this.item = res.data;
          this.changeTitle(this.item);
          this.isLoading = false;
        })

    },

    selectFile({src, alt}) {
    },

    changeTitle(itemObj) {
      this.$route.meta.pageTitle = this.$t("SETTINGS-HELP_TEXTS-DETAIL-HEADING") + " " + itemObj.name;

      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
    },

    save() {

      this.isSaving = true;
      this.axios.put('helptexts/'+this.item.id, this.item).then(res => {

        this.$store.dispatch('setSnackbar', { text: this.$t('GLOBAL-MESSAGE-SUCCESSFULLY_SAVED') });

      }).catch(err => {
          this.$store.dispatch('setSnackbar', { text: this.$t('GLOBAL-MESSAGE-ERROR'), type: 'warning' });
      })
      .finally(() => {
          this.isSaving = false;
      });

    }

  },
});
</script>

<style lang="scss" scoped>
</style>
